// Module
var code = `<breadcrumbs></breadcrumbs>
<section class="box">
  <sub-header header="'Organization'"></sub-header>

<div class="tab-menu">
  <ul class="nav-tabs">
    <li permissions="MNG_BRANCH_READ"
        ng-class="{active: isActive('/admin/organization/branches') || isActive('/admin/organization')}">
      <a data-target="#tab_branches" data-toggle="tab">
        <span>Branches</span>
      </a>
    </li>
    <li permissions="MNG_BRANCH_READ">
      <a data-target="#tab_areas" data-toggle="tab">
        <span>Areas</span>
      </a>
    </li>
    <li permissions="MNG_USER_WRITE"
        ng-class="{active: isActive('/admin/organization/users')}">
      <a data-target="#tab_users" data-toggle="tab">
        <span>Users</span>
      </a>
    </li>
    <li permissions="MNG_DEPOSITORY_ACCOUNT_READ"
        ng-class="{active: isActive('/admin/organization/depository-accounts')}">
      <a data-target="#tab_depository_accounts" data-toggle="tab">
        <span>Depository accounts</span>
      </a>
    </li>
    <li permissions="MNG_HOLIDAY_READ">
      <a data-target="#tab_holidays" data-toggle="tab">
        <span>Branch holidays</span>
      </a>
    </li>
    <li permissions="MNG_HOLIDAY_READ">
      <a data-target="#tab_bank_holidays" data-toggle="tab">
        <span>Bank holidays</span>
      </a>
    </li>
    <li permissions="SSS_CONTRIBUTIONS_READ"
        ng-class="{active: isActive('/admin/organization/sss/contributions')}">
      <a data-target="#tab_sss_contributions" data-toggle="tab">
        <span>SSS Contributions</span>
      </a>
    </li>
    <li command-access="UpdateGlobalSettings">
      <a data-target="#tab_global_settings" data-toggle="tab">
        <span>Global settings</span>
      </a>
    </li>
  </ul>
</div>

<div class="tab-content" style="overflow: unset">
  <div class="tab-pane"
       ng-class="{active: isActive('/admin/organization/branches') || isActive('/admin/organization')}"
       id="tab_branches">
    <div permissions="MNG_BRANCH_READ">
      <administration-branches></administration-branches>
    </div>
  </div>
  <div class="tab-pane"
       id="tab_areas">
    <div permissions="MNG_BRANCH_READ">
      <areas></areas>
    </div>
  </div>
  <div class="tab-pane"
       ng-class="{active: isActive('/admin/organization/users')}" id="tab_users">
    <div permissions="MNG_USER_WRITE">
      <users-branches></users-branches>
    </div>
  </div>
  <div class="tab-pane"
       ng-class="{active: isActive('/admin/organization/depository-accounts')}" id="tab_depository_accounts">
    <div permissions="MNG_DEPOSITORY_ACCOUNT_READ">
      <depository-account-list></depository-account-list>
    </div>
  </div>
  <div class="tab-pane" id="tab_holidays">
    <div permissions="MNG_HOLIDAY_READ">
      <holiday-branches></holiday-branches>
    </div>
  </div>
  <div class="tab-pane" id="tab_bank_holidays">
    <div permissions="MNG_HOLIDAY_READ">
      <bank-holidays></bank-holidays>
    </div>
  </div>
  <div class="tab-pane"
       ng-class="{active: isActive('/admin/organization/sss/contributions')}" id="tab_sss_contributions">
    <div permissions="SSS_CONTRIBUTIONS_READ">
      <sss-contributions></sss-contributions>
    </div>
  </div>
  <div class="tab-pane" id="tab_global_settings">
    <div>
      <global-settings></global-settings>
    </div>
  </div>
</div>
</section>
`;
// Exports
var _module_exports = code;;
var path = 'src/app/components/administration/organization/organization.template.html';
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, _module_exports) }]);
module.exports = path;